import React from 'react'
import upperCase from 'lodash/upperCase'
import { makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme'

const useEnvironmentLinkStyles = makeStyles(theme => ({
  root: {
    color: brandColors.gold2,
    fontSize: '14px',
    height: 14,
    lineHeight: 1,

    [theme.breakpoints.up('md')]: {
      height: 'auto',
    },
  },
}))

const EnvironmentLink = () => {
  const classes = useEnvironmentLinkStyles()

  if (__ENV__ === 'production') {
    return null
  }

  return (
    <Typography variant='button' className={classes.root} data-test='EnvironmentLink'>
      {upperCase(__ENV__ || '')}
    </Typography>
  )
}

export default EnvironmentLink
